import * as React from 'react';

import css from './style.css';


const DebugEntityMessage = () => (
  <div className={css.unsubscribePage}>
    <h2 className={css.questionText}>
      Since this is a test email, you cannot set your subscription preferences.
    </h2>
    <p className={css.footerText}>
      In normal emails, recipients can manage their existing preferences from
      this page.
    </p>
  </div>
);

export default DebugEntityMessage;
